// TODO implement PAYMENT_FAILED
export var ExitStep;
(function (ExitStep) {
    ExitStep["LIST"] = "LIST";
    ExitStep["ROOM"] = "ROOM";
    ExitStep["CHECKOUT"] = "CHECKOUT";
    ExitStep["CUSTOMER_FORM"] = "CUSTOMER_FORM";
    ExitStep["PAYMENT"] = "PAYMENT";
    ExitStep["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    ExitStep["BOOK"] = "BOOK";
})(ExitStep || (ExitStep = {}));
export var Device;
(function (Device) {
    Device["DESKTOP"] = "DESKTOP";
    Device["TABLET"] = "TABLET";
    Device["MOBILE"] = "MOBILE";
})(Device || (Device = {}));
export var MetaChannel;
(function (MetaChannel) {
    MetaChannel["NONE"] = "NONE";
    MetaChannel["TRIPADVISOR"] = "TRIPADVISOR";
    MetaChannel["TRIVAGO"] = "TRIVAGO";
    MetaChannel["GOOGLE"] = "GOOGLE";
})(MetaChannel || (MetaChannel = {}));
